import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp, FaTwitter, FaLinkedinIn,
  FaMapMarkerAlt, FaPhone, FaClock, FaEnvelope
} from 'react-icons/fa';

const socialLinks = [
  { name: 'Facebook',  href: 'https://www.facebook.com/people/Dr-Rahul-Naik-Neurologist/61585148137966/', Icon: FaFacebookF,  color: '#1877F2' },
  { name: 'Instagram', href: 'https://www.instagram.com/drrahulnaikneurologist', Icon: FaInstagram,  color: '#E1306C' },
  { name: 'YouTube',   href: 'https://www.youtube.com/channel/UCb7Nx4pGgEhc19tnPqcuw_w', Icon: FaYoutube,    color: '#FF0000' },
];

const Footer = () => {
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          <div className="footer-brand">
            <div className="footer-logo-row">
              <img src="/logo.png" alt="Naik Neuro Clinic" className="footer-logo-img" />
              <span className="footer-logo-text">Naik Neuro & <span className="footer-logo-accent">Skin Clinic</span></span>
            </div>
            <p className="footer-tagline">
              Expert neurological care in Nashik — led by an AIIMS-trained DM Neurologist.
            </p>
            <div className="footer-social">
              <p className="footer-social-label">Follow Us</p>
              <div className="footer-social-icons">
                {socialLinks.map(({ name, href, Icon, color }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-btn"
                    title={name}
                    style={{ '--social-color': color }}
                  >
                    <Icon size={17} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              {[
                { path: '/about',        label: 'About Dr. Naik' },
                { path: '/services',     label: 'Our Services' },
                { path: '/testimonials', label: 'Testimonials' },
                { path: '/contact',      label: 'Contact Us' },
              ].map(({ path, label }) => (
                <li key={label}>
                  <button className="footer-nav-btn" onClick={() => goTo(path)}>{label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Neurology Services</h4>
            <ul>
              {['Stroke & Cerebrovascular', 'Epilepsy & Seizures', 'Memory & Dementia',
                'Movement Disorders', 'Headache & Migraine', 'EEG / NCS / EMG'].map(s => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><FaMapMarkerAlt size={13} style={{marginRight:7, color:'var(--teal)'}} />Nashik, Maharashtra</li>
              <li><FaPhone size={12} style={{marginRight:7, color:'var(--teal)'}} />+91 9822180184</li>
              <li><FaClock size={12} style={{marginRight:7, color:'var(--teal)'}} />Mon–Sat: 10am–2pm</li>
              <li><FaClock size={12} style={{marginRight:7, color:'var(--teal)'}} />Evening: 5pm–8pm</li>
              <li><FaEnvelope size={12} style={{marginRight:7, color:'var(--teal)'}} />rahuldmneuro@gmail.com</li>
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <span>© 2026 Naik Neuro Clinic. All rights reserved.</span>
          <span>Design & Developed by Fluelite Technologies</span>       
          </div>
      </div>
    </footer>
  );
};

export default Footer;
